import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { ReactComponent as DeleteIcon } from "../assets/delete.svg";
import { ReactComponent as UploadIcon } from "../assets/upload.svg";

import UploadScreen from "./UploadScreen";
import {
  BackgroundLayout,
  ItemText,
  PageLayout,
  TitleText,
  TableItemText,
  TableDataText,
  TableDataButton,
  VerticalGap,
  ColumnLayout,
  RowStartLayout,
  ItemField,
  DatePickerField,
} from "../component";
import { fileTableItems } from "../assets/data";
import { axiosInstance } from "../axiosConfig";

const FileScreen = () => {
  const [uploadPopup, setUploadPopup] = useState(0);

  const { id } = useParams();

  const [project, setProject] = useState({});
  const [targetDate, setTargetDate] = useState("");
  const [files, setFiles] = useState([]);
  const [section, setSection] = useState(0);
  const [fileWriter, setFileWriter] = useState("");

  useEffect(() => {
    axiosInstance
      .get(`${process.env.REACT_APP_BASE_URL}/user/info`, {
        headers: {
          Authorization: `${localStorage.getItem("accessToken")}`,
        },
      })
      .then((res) => {
        setFileWriter(res.data.name);
      });
  }, []);

  useEffect(() => {
    axiosInstance
      .post(
        `${process.env.REACT_APP_BASE_URL}/project/info`,
        { id },
        {
          headers: {
            Authorization: `${localStorage.getItem("accessToken")}`,
          },
        }
      )
      .then((res) => {
        setProject(res.data);
        setTargetDate(res.data.startDate.slice(0, 7));
      });
  }, [id]);

  useEffect(() => {
    if (targetDate === "") return;
    const data = {
      projectId: id,
      date: targetDate,
    };
    try {
      axiosInstance
        .post(`${process.env.REACT_APP_BASE_URL}/file/section`, data, {
          headers: {
            Authorization: `${localStorage.getItem("accessToken")}`,
          },
        })
        .then((res) => {
          setFiles(res.data.file);
          setSection(res.data.section.id ?? 0);
        });
    } catch (error) {
      console.error(error);
    }
  }, [targetDate]);

  return (
    <PageLayout>
      {uploadPopup !== 0 && (
        <UploadScreen
          projectId={id}
          setClose={setUploadPopup}
          writer={fileWriter}
          fileNum={uploadPopup}
          workDate={targetDate}
        />
      )}
      <TitleText>안전문서 등록</TitleText>
      <VerticalGap height="10px" />
      <BackgroundLayout>
        <ColumnLayout
          style={{
            width: "50%",
          }}
        >
          <RowStartLayout>
            <ItemText>프로젝트 이름</ItemText>
            <ItemField>{project.projectName}</ItemField>
          </RowStartLayout>
          <RowStartLayout>
            <ItemText>현장 이름</ItemText>
            <ItemField>{project.fieldName}</ItemField>
          </RowStartLayout>
        </ColumnLayout>
        <ColumnLayout
          style={{
            width: "50%",
          }}
        >
          <RowStartLayout>
            <ItemText>Job code</ItemText>
            <ItemField>{project.jobCode}</ItemField>
          </RowStartLayout>
          <RowStartLayout>
            <ItemText>작업년월</ItemText>
            <DatePickerField
              type="month"
              value={targetDate}
              onChange={(e) => {
                setTargetDate(e.target.value);
              }}
              style={{ width: "100%" }}
            />
          </RowStartLayout>
        </ColumnLayout>
      </BackgroundLayout>
      <VerticalGap height="20px" />
      <FileTable
        section={section}
        items={fileTableItems}
        data={files}
        setPopUp={setUploadPopup}
      />
    </PageLayout>
  );
};

const FileTable = ({ section, items, data, setPopUp }) => {
  const handleFileClick = ({ item }) => {
    console.log(item);
    const fileUrl = `${process.env.REACT_APP_BASE_URL}/uploads/${item.fileName}`;
    window.open(fileUrl, "_blank");
  };
  const handleDelete = (id, num, title, name) => {
    if (!window.confirm(`${title}의 ${name}를 삭제하시겠습니까?`)) {
      return;
    }
    try {
      axiosInstance
        .delete(`${process.env.REACT_APP_BASE_URL}/file/delete`, {
          data: {
            fileId: id,
            fileNum: num,
            sectionId: section,
          },
          headers: {
            Authorization: `${localStorage.getItem("accessToken")}`,
          },
        })
        .then(() => {
          alert("삭제되었습니다.");
          window.location.reload();
        });
    } catch (error) {
      console.error(error);
      alert("삭제에 실패했습니다.");
    }
  };
  return (
    <TableLayout>
      {Object.keys(items).map((item, index) => (
        <TableItemText key={index}>{items[item]}</TableItemText>
      ))}
      {data.length > 0 &&
        data.map((item, index) => (
          <>
            <TableDataText
              style={{
                justifyContent: "center",
                backgroundColor: "var(--color-background)",
              }}
            >
              {index + 1}
            </TableDataText>
            <TableDataText>{item.title}</TableDataText>
            {item.fileName === null ? (
              <TableDataText style={{ justifyContent: "center" }}>
                <TableDataButton
                  onClick={() => {
                    setPopUp(index + 1);
                  }}
                >
                  <UploadIcon style={{ width: "16px" }} />
                  &nbsp;
                  <span className="blue">업로드</span>
                </TableDataButton>
              </TableDataText>
            ) : (
              <TableDataText>
                <TableDataButton onClick={() => handleFileClick({ item })}>
                  <span className="underline">
                    {item.fileName.slice(14, item.fileName.length)}
                  </span>
                </TableDataButton>
              </TableDataText>
            )}
            <TableDataText style={{ justifyContent: "center" }}>
              {item.writer}
            </TableDataText>
            <TableDataText>{item.memo}</TableDataText>
            <TableDataText style={{ justifyContent: "center" }}>
              <TableDataButton
                onClick={() =>
                  handleDelete(
                    item.id,
                    item.num,
                    item.title,
                    item.fileName.slice(14, item.fileName.length)
                  )
                }
              >
                <DeleteIcon style={{ width: "20px" }} />
              </TableDataButton>
            </TableDataText>
          </>
        ))}
    </TableLayout>
  );
};

const TableLayout = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 5fr 7fr 2fr 5fr 1fr;
  justify-content: center;
  align-items: center;
  background-color: var(--color-background);
  border-top: 1px solid var(--color-gray);

  & > div {
    border-right: 1px solid var(--color-gray);
    border-bottom: 1px solid var(--color-gray);
  }

  & > div:nth-child(6n + 1) {
    border-left: 1px solid var(--color-gray);
  }

  & > div:nth-child(6n) {
    border-right: 1px solid var(--color-gray);
  }
`;

export default FileScreen;
